export const models = {
    'cs-go': [
        {
            key: 'kills',
            value: 'id.performance.cs.totalKills'
        },
        {
            key: 'deaths',
            value: 'id.performance.cs.totalDeaths'
        },
        {
            key: 'kd',
            value: 'id.performance.cs.kd'
        },
        {
            key: 'adr',
            value: 'id.performance.cs.ard'
        },
        {
            key: 'kpr',
            value: 'id.performance.cs.kpr'
        },
        {
            key: 'winrate',
            value: 'id.performance.cs.winRate'
        },
        {
            key: 'headshotRate',
            value: 'id.performance.cs.headshotRate'
        },
        {
            key: 'accuracy',
            value: 'id.performance.cs.accuracy'
        },
        {
            key: 'hours',
            value: 'id.performance.cs.hoursPlayed'
        },
        {
            key: 'money',
            value: 'id.performance.cs.moneyEarned'
        },
        {
            key: 'rounds',
            value: 'id.performance.cs.roundsPlayed'
        },
        {
            key: 'matches',
            value: 'id.performance.cs.matchesPlayed'
        },
        {
            key: 'damage',
            value: 'id.performance.cs.totalDamage'
        },
        {
            key: 'wins',
            value: 'id.performance.cs.totalWins'
        },
        {
            key: 'loses',
            value: 'id.performance.cs.totalLoses'
        }
    ],
    'dota2': [
        {
            key: 'kills',
            value: 'id.performance.dota.kills'
        },
        {
            key: 'deaths',
            value: 'id.performance.dota.deaths'
        },
        {
            key: 'assists',
            value: 'id.performance.dota.assists'
        },
        {
            key: 'kda',
            value: 'id.performance.dota.kda'
        },
        {
            key: 'lastHits',
            value: 'id.performance.dota.lastHits'
        },
        {
            key: 'denies',
            value: 'id.performance.dota.denies'
        },
        {
            key: 'winrate',
            value: 'id.performance.dota.winRate'
        },
        {
            key: 'gpm',
            value: 'id.performance.dota.gpm'
        },
        {
            key: 'xpm',
            value: 'id.performance.dota.xpm'
        },
        {
            key: 'matches',
            value: 'id.performance.dota.matches'
        },
    ],
    'fifa-20': [
        {
            key: 'matches',
            value: 'id.performance.fifa20.matches'
        },
        {
            key: 'wins',
            value: 'id.performance.fifa20.wins'
        },
        {
            key: 'loses',
            value: 'id.performance.fifa20.loses'
        },
        {
            key: 'draws',
            value: 'id.performance.fifa20.draws'
        },
        {
            key: 'goals',
            value: 'id.performance.fifa20.goals'
        },
        {
            key: 'misses',
            value: 'id.performance.fifa20.misses'
        },
        {
            key: 'winrate',
            value: 'id.performance.fifa20.winrate'
        }
    ]
}